// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jl-0";
export var buttonContainer = "_jl-3";
export var cancelButton = "_jl-4";
export var headerSection = "_jl-6";
export var headerTitle = "_jl-9";
export var messageSideLeft = "_jl-1";
export var messageSideRight = "_jl-2";
export var orderNumberContainer = "_jl-7";
export var orderNumberLabel = "_jl-8";
export var submitButton = "_jl-5";